import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, logout} from "../../../features/user";
//import { setLoading} from "../../features/common";
import { useTranslation } from 'react-i18next';
import {checkValidToken, userLoggedIn} from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import ListCard from '../../widgets/ListCard';

export function EditList() {
    const [state, setState] = useState({ search: "" });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        checkValidToken(navigate, dispatch, false, true, "/start");
        userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)
       // eslint-disable-next-line
    },[]);


    const handleChange = (e) => {
        setState({
            ...state,
            [e.target.id]: e.target.value,
        });
    };

    return (
        <Frame headerWhite={true} showMenu={true} showNav={true}>
            <div className='main edit-list'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                    <Background >
                        <div className='right-main-inner'>
                            <ListCard title={"expert_editing_services"} items={[{name:"expert_editor_feedback"}, {name:"exprert_editor_writing_support"}, {name:"idea_development"}]}></ListCard>
                            <div className='mb40'></div>
                            <ListCard title={"editing_services"} items={[{name:"content_editing"}, {name:"technical_editing"}, {name:"proofreading"}, {name:"beta_readers"}]}></ListCard>
                            <div className='mb40'></div>
                            <ListCard title={"translation_services"} items={[{name:"hebrew_to_english"}, {name:"english_to_hebrew"}, {name:"other_languages"}]}></ListCard>
                            <div className='mb40'></div>
                        </div>
                    </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}